export const ChannelFilter = () => {

    document.body.addEventListener('htmx:load', function (evt) {
        htmx.config.requestClass = 'loading'

        const hash = window.location.hash.substring(1)
        if (hash === null) {
            return false
        }
        const targetElement = document.getElementById(`category-${hash}`)
        if (targetElement) {
            targetElement.dispatchEvent(new Event('click'))
            history.replaceState(null, null, ' ')
        }

    })
}